import Form from "../../components/form/form";
import Joi from "joi-browser";
import React from "react";
import "./certificate.css";
import { toast } from 'react-toastify';
import UserCertificatesService from "../../services/userCertificatesService";

export default class sendCertificate extends Form {

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            isLoading: false,
            certificateNo: ""
        };
    }

    state = {
        data: {
            CustomerEmail: ""
        },
        errors: {},
    };

    schema = {
        CustomerEmail: Joi.string().required().email({ minDomainSegments: 2, tlds: { allow: ['com', 'net', 'ir','org'] } }).error(new Error("آدرس ایمیل وارد شده نا معتبر است"))
    };

    doSubmit = async () => {
        const { data } = this.state;
        try {
            const result = await UserCertificatesService.sendCustomerCertificate(
                this.props.certificateNo,
                data.CustomerEmail
                );
            const isLoading = false;
            const showSuccessMessage = true;
            this.setState({ isLoading: isLoading });
            this.setState({ showSuccessMessage: showSuccessMessage });
        } catch (ex) {
            if (ex.code !== "ERR_NETWORK") {
                toast.error(ex.response.data.Message);
            }
            const isLoading = false;
            this.setState({ isLoading: isLoading });
        }
    };

    render() {
        return (
            <section>
                <div className="row certificatemodal">
                    <form onSubmit={this.handleSubmit} className="row justify-content-center" action="/">
                        <div className="col-11  mb-4">
                            {this.renderInput(
                                "CustomerEmail",
                                "",
                                "آدرس ایمیل",
                                "text",
                                "form-control form-control-lg",
                                "true"
                            )}
                        </div>
                        <div className="d-grid  col-11 mx-auto">
                            {this.renderButtonWithSpinner("دریافت گواهینامه", "btn btn-primary")}
                        </div>
                    </form>
                </div>
            </section>
        );
    }
}